









































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Select, Option } from '@/models/Configurator';

@Component
export default class ConfigSelect extends Vue {
    @Prop() variants!: Select;
    @Prop() value!: Array<Option>;
    @Prop({ default: '' }) currency!: string;
    @Prop() index!: number;
    public selectedValue: Option | null = null;
    expanded: boolean = false;
    
    constructor() {
        super();
    }
    private unexpand(e: FocusEvent) {
        if (e.relatedTarget == null || !this.$el.contains(e.relatedTarget as Node)) {
            this.expanded = false;
        }
    }

    private expand(e: PointerEvent, selectedList: Select) {
        const elem = e.target as HTMLElement;
        if (elem.classList.contains('config-select__info-hinging-icon')) {
            this.$emit('showModal', selectedList)
        } else {
            const isOpening = this.variants && !this.variants.open;
            this.$emit('selectedList', selectedList);

            if (isOpening) {
                this.$nextTick(() => {
                    this.$el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                });
            }
        };
    }

    get totalPrice(): string {
        if (!this.value || this.value.length === 0) {
            return '0'
        }
        
        const value = this.value.reduce((sum, item) => sum + item.price, 0);
        return new Intl.NumberFormat('sv-SE').format(value);
    }

    private setValue(val: Option | null, variants: Select | null ) {
        if (variants && variants.showInfo) {
            this.selectedValue = val;
        } else {
            this.selectedValue = null;
        }
    }

    private selectOption(val: Option, variants: Select) {
        if (variants.type === 'Sink') {
            this.$emit('setQuantity', val.quantityFaucets);
        }
        if (variants.type === 'DoorHinging') {
            this.$emit('setDoorHinging', val.name);
        }
        if (!variants.isMultiSelect) {
            this.value.shift();
            this.$emit('input', this.value.concat(val));
        } else {
            this.$emit(
                'input',
                this.value.indexOf(val) !== -1
                    ? this.value.filter(x => x.systemId !== val.systemId)
                    : this.value.concat(val)
            );
        }
    }

    private rowTotalCampaignPrice(options: Array<Option>): number {
        return options.reduce((prevVal: number, opt: Option) => {
            if (opt.campaignPrice && typeof opt.campaignPrice !== 'undefined')
                return prevVal + opt.campaignPrice * opt.quantity;
            else return prevVal + opt.price * opt.quantity;
        }, 0);
    }
    private rowTotalPrice(options: Array<Option>): number {
        return options.reduce((prevVal: number, opt: Option) => {
            return prevVal + opt.price * opt.quantity;
        }, 0);
    }

    private removeOption() {
        this.$emit('input', []);
        this.setValue(null, null);
    }
}
